import { render, staticRenderFns } from "./freightConfig.vue?vue&type=template&id=e7489194&scoped=true"
import script from "./freightConfig.vue?vue&type=script&lang=ts"
export * from "./freightConfig.vue?vue&type=script&lang=ts"
import style0 from "./freightConfig.vue?vue&type=style&index=0&id=e7489194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7489194",
  null
  
)

export default component.exports